import { DATA_TEST_IDS as PREVIEW_DATA_TEST_IDS } from '../MediafilePreview/consts';

export const DEFAULT_PREVIEW_DURATION = 10000;

export const DATA_TEST_IDS = {
  POSTER: 'media_preview_poster',
  TRIGGER: 'media_preview_trigger',
  EXTENSION: 'media_preview_extension',
  ...PREVIEW_DATA_TEST_IDS,
};
